const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快',
    desc: '7×24小时全天候追踪娱乐圈动态，重大突发事件30分钟内上线，让你永远快人一步吃到第一口瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '严格核实',
    desc: '每一条爆料都经过编辑团队多方核实，不传谣不信谣。无法确认的信息明确标注，让吃瓜群众理性判断。',
  },
  {
    icon: 'ri-lock-unlock-line',
    title: '永久免费',
    desc: '所有内容免费开放，无需注册登录即可浏览。不设付费墙、不搞会员制，吃瓜是每个人的权利。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">为什么选我们</span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">平台特色</h2>
          <p className="text-foreground-600 text-sm mt-2">51黑料网始终坚持的三大原则</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div key={i} className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all">
              <div className="w-14 h-14 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-3">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}